import { frameTexture0, frameTexture1, frameTexture2, frameTexture3, frameTexture4, frameTexture5, frameTexture6, frameTexture7, frameTexture8, frameTexture9, frameTexture10, frameTexture11, frameTexture12, frameTexture13, frameTexture14, frameTexture15, frameTexture34, frameTexture35, frameTexture36, frameTexture37, frameTexture38, frameTexture39, frameTexture40, frameTexture41, frameTexture42, frameTexture43, frameTexture44, frameTexture45, frameTexture46, frameTexture47, frameTexture48, frameTexture49, frameTexture50, frameTexture51, frameTexture52, frameTexture53, frameTexture54, frameTexture55, frameTexture56, frameTexture57, frameTexture58, frameTexture59 } from '../images/contemporary_frames'
import { frameTexture16, frameTexture17, frameTexture18, frameTexture19, frameTexture20, frameTexture21, frameTexture22, frameTexture23, frameTexture24, frameTexture25, frameTexture26, frameTexture27, frameTexture28, frameTexture29, frameTexture30, frameTexture31, frameTexture32, frameTexture33, frameTexture60, frameTexture61, frameTexture62, frameTexture63, frameTexture64, frameTexture65, frameTexture66, frameTexture67, frameTexture68, frameTexture69, frameTexture70, frameTexture71, frameTexture72, frameTexture73, frameTexture74, frameTexture75, frameTexture76, frameTexture77, frameTexture78, frameTexture79, frameTexture80, frameTexture81, frameTexture82, frameTexture83, frameTexture84 } from '../images/hardwood_frames'

// Asset metadata comes from the supplied JPG filenames and intrinsic dimensions.
// This indexes textures only; selectable products still come from the API.
const framingAssets = [
  {
    name: 'ALBANY',
    family: 'contemporary',
    widthInches: 0.875,
    assetUrl: frameTexture0,
    supplierCode: '84126',
  },
  {
    name: 'ATHENS',
    family: 'contemporary',
    widthInches: 0.875,
    assetUrl: frameTexture1,
    supplierCode: '78580',
  },
  {
    name: 'Albany',
    family: 'contemporary',
    widthInches: 0.875,
    assetUrl: frameTexture2,
    supplierCode: '84125',
  },
  {
    name: 'CHARLESTON',
    family: 'contemporary',
    widthInches: 1.25,
    assetUrl: frameTexture3,
    supplierCode: '83889',
  },
  {
    name: 'CHARLOTTE',
    family: 'contemporary',
    widthInches: 1.5,
    assetUrl: frameTexture4,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'COLUMBIA',
    family: 'contemporary',
    widthInches: 1.5,
    assetUrl: frameTexture5,
    supplierCode: '83531',
  },
  {
    name: 'CORINTH',
    family: 'contemporary',
    widthInches: 1.25,
    assetUrl: frameTexture6,
    supplierCode: '79523',
  },
  {
    name: 'CORSICA',
    family: 'contemporary',
    widthInches: 2.0,
    assetUrl: frameTexture7,
    supplierCode: null,
  },
  {
    name: 'CYPRUS',
    family: 'contemporary',
    widthInches: 0.75,
    assetUrl: frameTexture8,
    supplierCode: '83938',
  },
  {
    name: 'GENEVA',
    family: 'contemporary',
    widthInches: 1.25,
    assetUrl: frameTexture9,
    supplierCode: '79524',
  },
  {
    name: 'HARTFORD',
    family: 'contemporary',
    widthInches: 1.5,
    assetUrl: frameTexture10,
    supplierCode: '83530',
  },
  {
    name: 'NAPLES',
    family: 'contemporary',
    widthInches: 0.75,
    assetUrl: frameTexture11,
    supplierCode: '83961',
  },
  {
    name: 'RICHMOND',
    family: 'contemporary',
    widthInches: 0.875,
    assetUrl: frameTexture12,
    supplierCode: null,
  },
  {
    name: 'SAVANNAH',
    family: 'contemporary',
    widthInches: 1.625,
    assetUrl: frameTexture13,
    supplierCode: '83991',
  },
  {
    name: 'VENETIAN GOLD',
    family: 'contemporary',
    widthInches: 0.75,
    assetUrl: frameTexture14,
    reverseProfile: true,
    supplierCode: '203235',
  },
  {
    name: 'VENETIAN SILVER',
    family: 'contemporary',
    widthInches: 0.75,
    assetUrl: frameTexture15,
    reverseProfile: true,
    supplierCode: '203237',
  },
  {
    name: 'Aged Cherry',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture16,
    supplierCode: null,
  },
  {
    name: 'Aged Cherry',
    family: 'hardwood',
    widthInches: 1.25,
    assetUrl: frameTexture17,
    supplierCode: null,
  },
  {
    name: 'Aged Cherry',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture60,
    supplierCode: null,
  },
  {
    name: 'Antique Cherry',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture18,
    supplierCode: null,
  },
  {
    name: 'Antique Cherry',
    family: 'hardwood',
    widthInches: 1.25,
    assetUrl: frameTexture19,
    supplierCode: null,
  },
  {
    name: 'Antique Cherry',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture61,
    supplierCode: null,
  },
  {
    name: 'Black Cherry',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture20,
    supplierCode: null,
  },
  {
    name: 'Black Cherry',
    family: 'hardwood',
    widthInches: 1.25,
    assetUrl: frameTexture21,
    supplierCode: null,
  },
  {
    name: 'Black Cherry',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture62,
    supplierCode: null,
  },
  {
    name: 'Ebony Walnut',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture22,
    supplierCode: null,
  },
  {
    name: 'Ebony Walnut',
    family: 'hardwood',
    widthInches: 1.25,
    assetUrl: frameTexture23,
    supplierCode: null,
  },
  {
    name: 'Ebony Walnut',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture63,
    supplierCode: null,
  },
  {
    name: 'Rising Warm Ash',
    aliases: ['Rising White Ash'],
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture24,
    supplierCode: null,
  },
  {
    name: 'Rising Warm Ash',
    aliases: ['Rising White Ash'],
    family: 'hardwood',
    widthInches: 1.25,
    assetUrl: frameTexture25,
    supplierCode: null,
  },
  {
    name: 'Rising Warm Ash',
    aliases: ['Rising White Ash'],
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture64,
    supplierCode: null,
  },
  {
    name: 'Satin Black Maple',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture26,
    supplierCode: null,
  },
  {
    name: 'Satin Black Maple',
    family: 'hardwood',
    widthInches: 1.25,
    assetUrl: frameTexture27,
    supplierCode: null,
  },
  {
    name: 'Satin Black Maple',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture65,
    supplierCode: null,
  },
  {
    name: 'Satin Black Walnut',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture28,
    supplierCode: null,
  },
  {
    name: 'Satin Black Walnut',
    family: 'hardwood',
    widthInches: 1.25,
    assetUrl: frameTexture29,
    supplierCode: null,
  },
  {
    name: 'Satin Black Walnut',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture66,
    supplierCode: null,
  },
  {
    name: 'Special Dark Walnut',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture30,
    supplierCode: null,
  },
  {
    name: 'Special Dark Walnut',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture31,
    supplierCode: null,
  },
  {
    name: 'White Maple',
    showOutline: true,
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture32,
    supplierCode: null,
  },
  {
    name: 'White Maple',
    showOutline: true,
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture33,
    supplierCode: null,
  },
  {
    name: 'Bleached White Oak', 
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture67,
    supplierCode: null,
  },
  {
    name: 'Bleached White Oak',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture68,
    supplierCode: null,
  },
  {
    name: 'Dark Grey Ash',
    aliases: ['Dark Gray Ash'],
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture69,
    supplierCode: null,
  },
  {
    name: 'Dark Grey Ash',
    aliases: ['Dark Gray Ash'],
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture70,
    supplierCode: null,
  },
  {
    name: 'Light Grey Maple',
    aliases: ['Light Gray Maple'],
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture71,
    supplierCode: null,
  },
  {
    name: 'Light Grey Maple',
    aliases: ['Light Gray Maple'],
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture72,
    supplierCode: null,
  },
  {
    name: 'Medium Grey Maple',
    aliases: ['Medium Gray Maple'],
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture73,
    supplierCode: null,
  },
  {
    name: 'Medium Grey Maple',
    aliases: ['Medium Gray Maple'],
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture74,
    supplierCode: null,
  },
  {
    name: 'Oil and Wax Cherry',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture75,
    supplierCode: null,
  },
  {
    name: 'Oil and Wax Cherry',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture76,
    supplierCode: null,
  },
  {
    name: 'Oil and Wax Maple',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture77,
    supplierCode: null,
  },
  {
    name: 'Oil and Wax Maple',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture78,
    supplierCode: null,
  },
  {
    name: 'Oil and Wax Walnut',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture79,
    supplierCode: null,
  },
  {
    name: 'Oil and Wax Walnut',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture80,
    supplierCode: null,
  },
  {
    name: 'Satin Black Ash',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture81,
    supplierCode: null,
  },
  {
    name: 'Satin Black Ash',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture82,
    supplierCode: null,
  },
  {
    name: 'Whitewash Ash',
    family: 'hardwood',
    widthInches: 0.75,
    assetUrl: frameTexture83,
    supplierCode: null,
  },
  {
    name: 'Whitewash Ash',
    family: 'hardwood',
    widthInches: 1.5,
    assetUrl: frameTexture84,
    supplierCode: null,
  },
  {
    name: 'ADELAIDE BRONZE',
    family: 'contemporary',
    widthInches: 0.875,
    assetUrl: frameTexture34,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'ADELAIDE',
    family: 'contemporary',
    widthInches: 0.88,
    assetUrl: frameTexture35,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'GENEVA DARK',
    family: 'contemporary',
    widthInches: 2.75,
    assetUrl: frameTexture36,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'GENEVA GOLD',
    family: 'contemporary',
    widthInches: 2.75,
    assetUrl: frameTexture37,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'GENEVA SILVER',
    family: 'contemporary',
    widthInches: 2.75,
    assetUrl: frameTexture38,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'HELENA DARK',
    family: 'contemporary',
    widthInches: 2.5625,
    assetUrl: frameTexture39,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'HELENA',
    family: 'contemporary',
    widthInches: 2.5625,
    assetUrl: frameTexture40,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'MADISON',
    family: 'contemporary',
    widthInches: 1.625,
    assetUrl: frameTexture41,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'MONACO',
    family: 'contemporary',
    widthInches: 1.25,
    assetUrl: frameTexture42,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'RENATA',
    family: 'contemporary',
    widthInches: 1.25,
    assetUrl: frameTexture43,
    supplierCode: null,
  },
  {
    name: 'SYDNEY DARK',
    family: 'contemporary',
    widthInches: 2.25,
    assetUrl: frameTexture44,
    supplierCode: null,
  },
  {
    name: 'SYDNEY',
    family: 'contemporary',
    widthInches: 2.25,
    assetUrl: frameTexture45,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'VALENCIA BRASS THIN',
    family: 'contemporary',
    widthInches: 0.75,
    assetUrl: frameTexture46,
    supplierCode: null,
  },
  {
    name: 'VALENCIA BRASS WIDE',
    family: 'contemporary',
    widthInches: 1.125,
    assetUrl: frameTexture47,
    supplierCode: null,
  },
  {
    name: 'VALENCIA GOLD THIN',
    family: 'contemporary',
    widthInches: 0.75,
    assetUrl: frameTexture48,
    supplierCode: null,
  },
  {
    name: 'VALENCIA GOLD WIDE',
    family: 'contemporary',
    widthInches: 1.125,
    assetUrl: frameTexture49,
    supplierCode: null,
  },
  {
    name: 'VALENCIA ROSE THIN',
    family: 'contemporary',
    widthInches: 0.75,
    assetUrl: frameTexture50,
    supplierCode: null,
  },
  {
    name: 'VALENCIA ROSE WIDE',
    family: 'contemporary',
    widthInches: 1.125,
    assetUrl: frameTexture51,
    supplierCode: null,
  },
  {
    name: 'VALENCIA SILVER THIN',
    family: 'contemporary',
    widthInches: 0.75,
    assetUrl: frameTexture52,
    supplierCode: null,
  },
  {
    name: 'VALENCIA SILVER WIDE',
    family: 'contemporary',
    widthInches: 1.125,
    assetUrl: frameTexture53,
    supplierCode: null,
  },
  {
    name: 'VENETIAN GOLD THIN',
    family: 'contemporary',
    widthInches: 0.75,
    assetUrl: frameTexture54,
    reverseProfile: true,
    supplierCode: null,
    aliases: ['VENETIAN GOLD 0.75"'],
  },
  {
    name: 'VENETIAN GOLD WIDE',
    family: 'contemporary',
    widthInches: 1.25,
    assetUrl: frameTexture55,
    reverseProfile: true,
    supplierCode: null,
    aliases: ['VENETIAN GOLD 1.25"'],
  },
  {
    name: 'VENETIAN SILVER THIN',
    family: 'contemporary',
    widthInches: 0.75,
    assetUrl: frameTexture56,
    reverseProfile: true,
    supplierCode: null,
    aliases: ['VENETIAN SILVER 0.75"'],
  },
  {
    name: 'VENETIAN SILVER WIDE',
    family: 'contemporary',
    widthInches: 1.25,
    assetUrl: frameTexture57,
    reverseProfile: true,
    supplierCode: null,
    aliases: ['VENETIAN SILVER 1.25"'],
  },
  {
    name: 'VERONA',
    family: 'contemporary',
    widthInches: 1.75,
    assetUrl: frameTexture58,
    reverseProfile: true,
    supplierCode: null,
  },
  {
    name: 'VIENNA',
    family: 'contemporary',
    widthInches: 1.25,
    assetUrl: frameTexture59,
    reverseProfile: true,
    supplierCode: null,
  },
]

export default framingAssets
